import dayjs from 'dayjs'
const myPlugin = {}

myPlugin.install = (Vue) => {
  Vue.filter('format', (val, str = 'YYYY-MM-DD HH:mm:ss') => {
    return dayjs(val).format(str)
  })
  Vue.mixin({
    methods: {
      clickLeft (name) {
        if (name) {
          this.$router.push({
            name
          })
        } else {
          this.$router.go(-1)
        }
      }
    }

  })
}

export default myPlugin
